/* eslint-disable no-magic-numbers */

// 轴线，分割线
const LINE_COLOR = [0.4, 0.06];

type LineLevel = 1 | 2;

export const LINE_LEVEL_LIST: Record<string, LineLevel> = {
  LEVEL1: 1,
  LEVEL2: 2
};

export function lineColor(level: LineLevel, theme?: 'light' | 'dark') {
  const mode = theme || 'light';
  const color = mode === 'light' ? 0 : 255;
  return `rgba(${color}, ${color}, ${color}, ${LINE_COLOR[level - 1]})`;
}

export function splitLineStyle(level: LineLevel, theme?: 'light' | 'dark', isZero = false) {
  const mode = theme || 'light';
  const stroke = mode === 'light' ? '#000' : '#FFF';
  const opacity = LINE_COLOR[level - 1];
  const lineWidth = isZero ? 1 : 0.5;
  const result: any = {
    stroke,
    opacity,
    lineWidth
  };
  if (isZero) {
    result.lineDash = [5, 4];
  }
  return result;
}
